import FrontAPIAdapter from './FrontAPIAdapter';
import StorefrontAdapter from './StorefrontAdapter';

function hasStorefront() {
    return typeof window !== 'undefined' && typeof window.useStorefront === 'function';
}

export default class ApiAdapter {
    debug = true;
    errorDemoMode = false;

    constructor(adapter = null) {
        this.adapter = adapter || (hasStorefront() ? new StorefrontAdapter() : new FrontAPIAdapter());
        console.log(`ApiAdapter using ${this.adapter.constructor.name}`);
    }

    setAdapter(adapter) {
        this.adapter = adapter;
    }

    setErrorDemoMode(bool) {
        this.errorDemoMode = !!bool;
        if (this.adapter?.setErrorDemoMode) {
            this.adapter.setErrorDemoMode(this.errorDemoMode);
        }
        return this.errorDemoMode;
    }

    async call(method, ...args) {
        if (this.debug) {
            console.log(`[ApiAdapter] ${method} ->`, args);
        }
        try {
            const result = await this.adapter[method](...args);
            if (this.debug) {
                console.log(`[ApiAdapter] ${method} <-`, result);
            }
            return result;
        } catch (err) {
            if (this.debug) {
                console.error(`[ApiAdapter] ${method} ERROR`, err);
            }
            throw err;
        }
    }

    addToBasket(data) {
        return this.call('addToBasket', data);
    }

    removeFromBasket(id) {
        return this.call('removeFromBasket', id);
    }

    getBasket() {
        return this.call('getBasket');
    }

    getProduct(id) {
        return this.call('getProduct', id);
    }
}

export const apiAdapter = new ApiAdapter();
